import { DcBaseComponent } from '@deleteagency/dc';

const RECENTLY_VIEWED_PROPERTIES_KEY = 'winkworth_recently_viewed_properties_key';
const MAX_PROPERTIES_TO_SHOW = 3;
export default class PropertyId extends DcBaseComponent {
    constructor(element) {
        super(element);
        this.propertyId = this.options.propertyId;
    }

    static getNamespace() {
        return 'property-id';
    }

    onInit() {
        this.updateStore();
    }

    updateStore = () => {
        const propertyIds = this.getViewedPropertyIds();

        if (propertyIds) {
            let modifiedIds = new Set(propertyIds.slice(0));

            if (!modifiedIds.has(this.propertyId)) {
                modifiedIds.add(this.propertyId);
            }

            if (modifiedIds.size > MAX_PROPERTIES_TO_SHOW) {
                modifiedIds = new Set([...modifiedIds].slice(-MAX_PROPERTIES_TO_SHOW));
            }

            this.setViewedPropertyId([...modifiedIds]);
        } else {
            this.setViewedPropertyId([this.propertyId]);
        }
    };

    getViewedPropertyIds = () => JSON.parse(localStorage.getItem(RECENTLY_VIEWED_PROPERTIES_KEY));

    setViewedPropertyId = id =>
        localStorage.setItem(RECENTLY_VIEWED_PROPERTIES_KEY, JSON.stringify(id));
}
